import { createTheme } from '../theme';

const theme = createTheme({
  components: {
    MuiStepper: {
      styleOverrides: {
        root: ({ theme: { unstable_sx: sx, ...theme } }) =>
          sx({
            '& .MuiStepConnector-line': {
              borderColor: theme.palette.grey[200],
            },
          }),
      },
    },
  },
});

export default theme.components;
